import $ from 'jquery';

class Insights {
  constructor() {
    this.insightsContainer = $('#js-insights');
    this.initAjaxNav();
    this.initPopState();
  }

  initAjaxNav() {
    // Delegate events to the stable container
    this.insightsContainer.on(
      'click',
      '.js-insights-nav-link, .c-pagination .c-page-link',
      e => {
        const link = $(e.currentTarget);
        const url = link.attr('href');

        if (url && url !== '#') {
          e.preventDefault();
          this.loadContent(url);
        }
      },
    );
  }

  initPopState() {
    window.onpopstate = e => {
      if (e.state && e.state.path) {
        this.loadContent(e.state.path, false);
      }
    };
  }

  loadContent(url, pushState = true) {
    this.insightsContainer.css('opacity', 0.5);

    $.get(url)
      .done(response => {
        const newContent = $(response)
          .find('#js-insights')
          .html();
        const newTitle = $(response)
          .filter('title')
          .text();

        this.insightsContainer.html(newContent);
        document.title = newTitle;

        if (pushState) {
          // Remove hash from URL for pushState
          const cleanUrl = url.split('#')[0];
          window.history.pushState({ path: cleanUrl }, newTitle, cleanUrl);
        }

        this.insightsContainer.css('opacity', 1);

        if (window.AOS) {
          window.AOS.refresh();
        }

        // Scroll to top of the insights container
        $('body, html')
          .stop()
          .animate(
            {
              scrollTop: this.insightsContainer.offset().top - 100, // 100px offset for sticky header
            },
            500,
          );
      })
      .fail(() => {
        window.location.href = url;
      });
  }
}

export default new Insights();



// WEBPACK FOOTER //
// ./src/scripts/modules/insights.js